import React from 'react';
import { Badge } from '@/components/ui/badge';
import { BUSINESS_UNITS } from '@/constants/businessUnits';
import { usePaymentRequestAllocations } from '@/hooks/finance/usePaymentRequestAllocations';

interface Props {
  paymentRequestId?: string | null;
  fallbackBusinessUnit?: string | null;
  label?: string;
  className?: string;
}

export const PaymentRequestAllocationsBadges: React.FC<Props> = ({
  paymentRequestId,
  fallbackBusinessUnit,
  label = 'Business Unit Allocation',
  className,
}) => {
  const { data: allocations, isLoading } = usePaymentRequestAllocations(paymentRequestId);

  const rows =
    allocations && allocations.length > 0
      ? allocations
      : fallbackBusinessUnit
      ? [{ business_unit: fallbackBusinessUnit as any, percentage: 100 }]
      : [];

  return (
    <div className={className}>
      <div className="text-xs font-medium text-muted-foreground mb-1">{label}</div>
      {isLoading ? (
        <span className="text-xs text-muted-foreground">Loading…</span>
      ) : rows.length === 0 ? (
        <span className="text-xs text-muted-foreground">—</span>
      ) : (
        <div className="flex flex-wrap gap-1.5">
          {rows.map((r) => {
            const bu = BUSINESS_UNITS.find((b) => b.value === r.business_unit);
            const color = bu?.color ?? 'hsl(var(--muted-foreground))';
            const lbl = bu?.label ?? r.business_unit;
            return (
              <Badge
                key={r.business_unit}
                variant="outline"
                style={{ borderColor: color, color }}
              >
                {lbl} · {Number(r.percentage)}%
              </Badge>
            );
          })}
        </div>
      )}
    </div>
  );
};
